// extracted by mini-css-extract-plugin
module.exports = {"modal":"aa2fbb","modal__header":"_399d7d","modal__header-btn":"_7a1a69","modal__title":"_93f015","modal__form-input":"_5dc65d","modal__form-btn":"_2bd394"};